export enum CustomRecurrenceMode {
    Day = 0,
    Week,
    Month,
    Year
}
